import React from 'react';
import RadioButton from './RadioButton';

interface RadioCardProps {
  title: string;
  isSelected: boolean;
  onSelect: () => void;
  children: React.ReactNode;
  className?: string;
}

const RadioCard: React.FC<RadioCardProps> = ({
  title,
  isSelected,
  onSelect,
  children,
  className = '',
}) => {
  return (
    <div
      className={`border rounded-lg cursor-pointer transition-all duration-200 bg-white ${
        isSelected
          ? 'border-[#DA291C]'
          : 'border-gray-300 hover:border-gray-400'
      } ${className}`}
      style={{
        boxShadow: isSelected
          ? '0 10px 15px -3px rgba(218, 41, 28, 0.1), 0 4px 6px -2px rgba(218, 41, 28, 0.05)'
          : '0 1px 3px 0 rgba(107, 114, 128, 0.1), 0 1px 2px 0 rgba(107, 114, 128, 0.06)',
      }}
      onClick={onSelect}
    >
      {/* Header with title and radio button */}
      <div className="flex items-center justify-between p-4 pb-3">
        <h4 className="text-[#1F1F1F] text-[16px] font-semibold leading-[20px]">
          {title}
        </h4>
        <RadioButton selected={isSelected} onPress={onSelect} label="" />
      </div>

      {/* Content area */}
      <div className="px-4 pb-4">{children}</div>
    </div>
  );
};

export default RadioCard;
